var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 13.25 3.2375 14.4208 3.7125 15.5125C4.1875 16.6042 4.82917 17.5542 5.6375 18.3625C6.44583 19.1708 7.39583 19.8125 8.4875 20.2875C9.57917 20.7625 10.75 21 12 21C13.25 21 14.4208 20.7625 15.5125 20.2875C16.6042 19.8125 17.5542 19.1708 18.3625 18.3625C19.1708 17.5542 19.8125 16.6042 20.2875 15.5125C20.7625 14.4208 21 13.25 21 12L19 12C19 13.95 18.3208 15.6042 16.9625 16.9625C15.6042 18.3208 13.95 19 12 19C10.05 19 8.39583 18.3208 7.0375 16.9625C5.67917 15.6042 5 13.95 5 12L3 12ZM7 8L8.425 9.4L11 6.825L11 15L13 15L13 6.825L15.6 9.4L17 8L12 3L7 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFront);
export default __webpack_public_path__ + "static/media/icon-front.898f553435cacd62fb39ee74347ff042.svg";
export { ForwardRef as ReactComponent };